var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center min-vh-100 p-3 text-center",staticStyle:{"background-color":"#f8f9fa"}},[_c('h1',[_vm._v("404")]),_c('VueLoadingOverlay',{attrs:{"active":_vm.showLoading,"is-full-page":true},on:{"update:active":function($event){_vm.showLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }